import * as React from "react"
import { cn } from "@/lib/utils"

export interface TelegramIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Telegram icon as SVG
 *
 * This icon represents the Telegram messaging platform.
 *
 * @example
 * ```tsx
 * <TelegramIcon />
 * <TelegramIcon size={24} className="text-blue-500" />
 * ```
 */
export const TelegramIcon = React.forwardRef<SVGSVGElement, TelegramIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M9 0C4.02979 0 0 4.02979 0 9C0 13.9702 4.02979 18 9 18C13.9702 18 18 13.9702 18 9C18 4.02979 13.9702 0 9 0ZM13.3672 6.14697C13.2009 7.80176 12.5254 11.6816 12.1792 13.4717C12.0317 14.2236 11.7422 14.4761 11.4634 14.502C10.8574 14.5591 10.397 14.1016 9.80664 13.708C8.86523 13.0859 8.32861 12.7036 7.41943 12.0972C6.36328 11.3936 7.02979 11.0112 7.62012 10.3989C7.77539 10.2363 10.4873 7.77246 10.5381 7.55225C10.5445 7.52246 10.5508 7.41162 10.4849 7.35303C10.4189 7.29443 10.3223 7.31494 10.252 7.33252C10.1523 7.35742 8.68066 8.37891 5.8125 10.4019C5.38379 10.6973 4.99805 10.8413 4.65527 10.834C4.27783 10.8257 3.55127 10.6206 3.00977 10.4448C2.34326 10.2319 1.81494 10.1187 1.86182 9.75049C1.88623 9.55957 2.15332 9.36377 2.66309 9.16309C5.73633 7.89404 7.74561 7.05811 8.69092 6.65527C11.6162 5.49316 12.1909 5.2959 12.5767 5.2959C12.6616 5.2959 12.8521 5.31641 12.9722 5.41553C13.0723 5.49756 13.1001 5.60889 13.1133 5.68799C13.1001 5.74658 13.1265 5.94873 13.3672 6.14697Z" />
      </svg>
    )
  }
)

TelegramIcon.displayName = "TelegramIcon"
